import { injectable } from "inversify";
import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../../entities/ErrorEntity";
import UserRepository from "../../repositories/UserRepository";
import UserEntity from "../../entities/UserEntity";

interface _Props {
    userRepository: UserRepository;
}
@injectable()
export default class CreateUserUseCase {
    private userRepository: UserRepository;
    constructor(props: _Props) {
        this.userRepository = props.userRepository;
    }
    public call = async (_:{
        user: UserEntity,
        password: string,
    }) : Promise<Either<ErrorEntity, UserEntity>> => {
        return this.userRepository.createUser(_);
    }
}

export const CreateUserUseCaseName = "CreateUserUseCase";